import 'magnific-popup'
import { sanitize } from 'isomorphic-dompurify'
import { createApp } from 'vue'
import FButton from '~/js/components/button'
import FLinkCard from '~/js/components/linkCard'
import FModal from '~/js/components/modal'
import FProductsList from '~/js/components/productsList'
import FTab from '~/js/components/tab'
import { LinkItem } from '~/js/models/linkItem'
import { TabItem } from '~/js/models/tabItem'
import {
  favouriteCoordinateHandles,
  isDesktop,
  baseUrlFrontApi,
} from '~/js/templates/index/helpers'

import { initProductPage } from '~/js/product-page'
import {
  getItemsFromIds,
  getProductFromHandle,
  getRecentProductIds,
} from '~/js/helpers/getProducts'
import { Sticky } from '~/js/helpers/sticky'
import '~/js/snippets/recent-items'
import '~/js/templates/index/categories'
import '~/js/templates/index/hashtags'
import '~/js/templates/index/news'
import { initStoresStockModal } from './initStoresStockModal'
import './productList'
import './review'
import './qa'
import { initProductMediaViewer } from './productMediaViewer'
import './productPriceBox'
import './recentProduct'
import axios from 'axios'
import '~/js/sections/collectionItems'
import '~/js/snippets/image-slider'
import { addToCart } from '~/js/helpers/addToCart'
import { getFSFilteredProducts } from '~/js/helpers/getFSProducts'
import '~/js/helpers/scroll'
import { pushCartAddedEvent } from '~/js/gtm'

const ID_STICKY_ON_MOBILE_TRIGGER = 'js-stickyOnMobileTrigger'
const ID_HEADER = 'js-snippetsHeader'
const ID_PRODUCT_COORDINATES = 'js-product-coordinates'
const ID_PRODUCT_MEDIA_VIEWER_DESKTOP = 'js-product-media-viewer-desktop'
const ID_PRODUCT_MEDIA_VIEWER_MOBILE = 'js-product-media-viewer-mobile'
const ID_TAB = 'js-product-tab'
const ID_VARIANT_SELECTOR = 'js-product-variant-selector'
const CLASS_NAME_MODAL = 'js-modal-product-stock'
const CLASS_NAME_PRODUCT_SOCIAL_PROOF = 'js-product-social-proof'
const CLASS_NAME_STICKY_ON_MOBILE_ITEM = 'js-stickyOnMobileItem'

const PRODUCTS_SLIDER_RECENT = 'js-product-products-list-recent'
const PRODUCTS_SLIDER_CATEGORY = 'js-product-products-list-category'
const PRODUCTS_SLIDER_RANKING = 'js-product-products-list-ranking'

const tabItemTitles = ['商品説明', 'サイズ・素材', '配送について', '注意事項']
const tabItems = tabItemTitles.map((title) => new TabItem({ title }))

const cookies = {}
document.cookie.split(';').forEach((cookie) => {
  const [key, value] = cookie.split('=').map((string) => string.trim())
  cookies[key] = value
})
const QUERY_PRODUCT_FORM = '.product__form[action="/cart/add"]'

document.addEventListener('DOMContentLoaded', async () => {
  const elementsProductForm = document.querySelectorAll(QUERY_PRODUCT_FORM)
  if (!elementsProductForm.length) return

  elementsProductForm.forEach((element) => {
    element.addEventListener('submit', async (event) => {
      event.preventDefault
      const form = event.target
      const item = {
        handle: form.dataset.productHandle,
        id: form.elements['id']?.value,
        image: form.elements['product-image']?.value,
        productTitle: form.elements['product-title']?.value,
        productTitlePrefix: form.dataset.productTitlePrefix || '',
        quantity: form.elements['product-quantity']?.value || 1,
      }
      const { itemsAdded, itemsAddFailed } = await addToCart([item])
      window.dispatchEvent(
        new CustomEvent('cart-added', {
          detail: { items: itemsAdded, itemsAddFailed },
        })
      )
      pushCartAddedEvent({ items: itemsAdded, itemsAddFailed })
    })
  })

  if (isDesktop()) {
    const elementsStickyContainer =
      document.getElementsByClassName('js-stickyContainer')
    if (elementsStickyContainer.length) {
      const elementHeader = document.getElementById(ID_HEADER)
      const headerHeight = elementHeader.dataset.height

      Array.from(elementsStickyContainer).forEach((element) => {
        new Sticky(element, { offset: headerHeight })
      })
    }
  } else {
    const elementsStickyOnMobileItem = document.getElementsByClassName(
      CLASS_NAME_STICKY_ON_MOBILE_ITEM
    )
    if (elementsStickyOnMobileItem.length) {
      Array.from(elementsStickyOnMobileItem).forEach((element) => {
        initStickyOnMobile(element)
      })
    }
  }

  const id = isDesktop()
    ? ID_PRODUCT_MEDIA_VIEWER_DESKTOP
    : ID_PRODUCT_MEDIA_VIEWER_MOBILE
  const elementProductMediaViewer = document.getElementById(id)
  if (elementProductMediaViewer)
    initProductMediaViewer(elementProductMediaViewer)

  const elementsProductSocialProof = document.getElementsByClassName(
    CLASS_NAME_PRODUCT_SOCIAL_PROOF
  )
  if (elementsProductSocialProof) {
    const url = `${baseUrlFrontApi}/pdpview`

    Array.from(elementsProductSocialProof).forEach(async (element) => {
      const p = element.dataset.productHandle
      const pvCount = await axios
        .post(url, { p, y: cookies._shopify_y })
        .then((r) => r.data)
        .catch((_) => {
          element.remove()
        })
      if (pvCount > 0) {
        element
          .querySelectorAll('.js-product-social-proof-pv')
          .forEach((el) => {
            el.innerText = `${pvCount}人`
          })
      } else {
        element.remove()
      }
    })
  }

  const elementCoordinate = document.getElementById(ID_PRODUCT_COORDINATES)
  if (elementCoordinate) initCoordinate(elementCoordinate)

  const elementTab = document.getElementById(ID_TAB)
  if (elementTab) initTab(elementTab)

  const elementVariantSelector = document.getElementById(ID_VARIANT_SELECTOR)
  if (elementVariantSelector) initVariantSelector(elementVariantSelector)

  const elementsModal = document.getElementsByClassName(CLASS_NAME_MODAL)
  if (elementsModal.length)
    Array.from(elementsModal).forEach((element) =>
      initStoresStockModal(element)
    )

  // 最近チェックした商品から探す
  const elementsProductsListRecent = document.getElementsByClassName(
    PRODUCTS_SLIDER_RECENT
  )
  if (elementsProductsListRecent.length) {
    const recentProductIds = getRecentProductIds().slice(1, 17) // 1個目は現在見ている商品のため、2個目から取得
    Array.from(elementsProductsListRecent).forEach(async (element) => {
      if (!recentProductIds.length) {
        element.remove()
      }

      try {
        const products = await getItemsFromIds(recentProductIds)
        if (products.length)
          initProductsList(
            element,
            products.filter((v) => v)
          )
      } catch (e) {
        console.error(e)
        return []
      }
    })
  }

  // 同じカテゴリの商品から探す
  const elementsProductsListCategory = document.getElementsByClassName(
    PRODUCTS_SLIDER_CATEGORY
  )
  if (elementsProductsListCategory.length) {
    Array.from(elementsProductsListCategory).forEach(async (element) => {
      const idsString = element.dataset.ids
      const ids = JSON.parse(idsString)
      const products = await getItemsFromIds(ids)
      if (products.length) initProductsList(element, products)
    })
  }

  // 同じカテゴリの人気ランキングから探す
  const elementsProductsListRanking = document.getElementsByClassName(
    PRODUCTS_SLIDER_RANKING
  )

  if (elementsProductsListRanking.length) {
    Array.from(elementsProductsListRanking).forEach(async (element) => {
      const collectionId = element.dataset.collectionId
      const productSort = 'mf-ranking-count_of_sales-descending'
      const callback = `products-list-ranking_${collectionId}_${productSort}`
      const { products } = await getFSFilteredProducts({
        collectionId,
        productSort,
        limit: 20,
        callback,
      })
      if (products.length) initProductsList(element, products)
    })
  }
})

const initStickyOnMobile = (element) => {
  const elementStickyOnMobileTrigger = document.getElementById(
    ID_STICKY_ON_MOBILE_TRIGGER
  )

  window.addEventListener('scroll', () => {
    const breakPointStartSticky = elementStickyOnMobileTrigger
      ? elementStickyOnMobileTrigger.offsetTop +
        elementStickyOnMobileTrigger.clientHeight
      : 0
    if (window.scrollY > breakPointStartSticky) {
      element.classList.add('isShow')
    } else {
      element.classList.remove('isShow')
    }
  })
}

const initProductsList = (element, products) => {
  createApp({
    name: 'TemplatesProductsList',
    components: {
      FProductsList,
    },
    data() {
      return {
        products,
      }
    },
    mounted() {
      window.zvRenderReviewSummary(element)
    },
  }).mount(element)
}

// この商品をつかったコーディネート
const initCoordinate = (element) => {
  const SHOW_COUNT = 8
  const linkItems = JSON.parse(element.dataset.linkItems).map((linkItem) => {
    const url = `/blogs/coordinate/${linkItem.handle}`
    const isFavourite = favouriteCoordinateHandles.includes(linkItem.handle)
    return new LinkItem(linkItem, url, isFavourite)
  })

  createApp({
    name: 'TemplatesProductCoordinates',
    components: {
      FButton,
      FLinkCard,
    },
    data() {
      return {
        height: isDesktop() ? 180 : null,
        linkItems,
        showCount: SHOW_COUNT,
      }
    },
    computed: {
      linkItemsToShow() {
        return this.linkItems.slice(0, this.showCount)
      },
      hasMore() {
        return this.linkItems.length > this.showCount
      },
    },
    methods: {
      onShowMoreClicked() {
        this.showCount += SHOW_COUNT
      },
    },
  }).mount(element)
}

const initTab = (element) => {
  const productContent = element.dataset.productContent
  const productContentSanitized = sanitize(productContent, {
    ADD_ATTR: ['target'],
  })
  createApp({
    name: 'TemplatesProductTab',
    components: {
      FModal,
      FTab,
    },
    data() {
      return {
        tabItems,
        currentIndex: 0,
        showModalCurtainFeatures: false,
        productContentSanitized,
      }
    },
    created() {
      this.setTabItems(this.currentIndex)
    },
    methods: {
      setTabItems(index) {
        this.currentIndex = index
        this.tabItems.forEach((item, i) => {
          item.isSelected = i === this.currentIndex
        })
      },
    },
  }).mount(element)
}

const initVariantSelector = async (element) => {
  const variantHandlesString = element.dataset.variantHandles
  const handle = element.dataset.handleSelected
  const variantHandles = JSON.parse(variantHandlesString)
  if (variantHandles.length > 1) {
    const variants = await Promise.all(
      variantHandles.map(async (variantHandle) => {
        const product = await getProductFromHandle(variantHandle)
        return product
          ? {
              handle: product.handle,
              image: product.images[0],
              title: product.title,
              isSelected: product.handle == handle,
            }
          : null
      })
    )
    const variantsAvailable = variants.filter((v) => v)
    if (variantsAvailable.length > 1) element.style = undefined
    createApp({
      name: 'TemplatesProductVariantSelector',
      data() {
        return {
          variants: variantsAvailable,
        }
      },
    }).mount(element)
  }
}

initProductPage()

$(document).on('click', '.chatbot-pdp-btn', function () {
  $('.widget-chat-button.standard').click()
})
